if (!customElements.get('ls-cart-wallet-row')) {
  customElements.define('ls-cart-wallet-row', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const template = this.querySelector('template');
      if (!template) return;
      const content = template.content.cloneNode(true);
      const checkout = content.querySelector('shopify-accelerated-checkout-cart');
      if (checkout) {
        try {
          const configs = JSON.parse(checkout.getAttribute('wallet-configs') || '[]');
          const order = ['shop_pay', 'paypal', 'google_pay'];
          const visible = configs.filter(config => order.includes(config.name));
          visible.sort((a, b) => order.indexOf(a.name) - order.indexOf(b.name));
          checkout.setAttribute('wallet-configs', JSON.stringify(visible));
        } catch (error) {
          console.warn('Unable to arrange cart wallets; keeping the native checkout options.');
        }
      }
      this.dataset.ready = 'true';
      this.append(content);
      template.remove();
    }
  });
}
